import { Search } from 'lucide-react'
import { Input } from '../ui/input'
import { FormLabel } from './form-label'
import type { LucideIcon } from 'lucide-react'

interface IconInputProps extends React.ComponentProps<typeof Input> {
  icon?: LucideIcon
  iconClassName?: string
  label?: string
  field?: {
    state: {
      meta: {
        errors: Array<string>
      }
    }
  }
  error?: string
}

export default function IconInput({
  icon: Icon = Search,
  iconClassName,
  label,
  field,
  error,
  required,
  ...props
}: IconInputProps) {
  const displayError = error || field?.state.meta.errors[0]
  const isRequired = required || false

  return (
    <div className="space-y-2">
      {label && (
        <FormLabel htmlFor={props.id || props.name} required={isRequired}>
          {label}
        </FormLabel>
      )}
      <div>
        <div className="relative flex items-center rounded-md border focus-within:ring-1 focus-within:ring-ring pl-2">
          <Icon
            className={`h-5 w-5 text-muted-foreground ${iconClassName || ''}`}
          />
          <Input
            {...props}
            className="border-0 focus-visible:ring-0 shadow-none"
            aria-invalid={!!displayError}
            aria-required={isRequired}
          />
        </div>
        {displayError && (
          <div className="text-xs text-destructive">{displayError}</div>
        )}
      </div>
    </div>
  )
}
